/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState, useEffect } from 'react'
import Styles from './styles.module.sass'
import { useBreakpointValue } from '@chakra-ui/react'
import { getLlmGeographies } from '@/services/llm-geographies'
import { useAuth0 } from '@auth0/auth0-react'
import InputCheckboxes from '../../InputCheckboxes'
import CircleLoader from '@/components/loaders/CircleLoader'

const GeographiesCheckboxes = ({
  defaultValue,
  errors,
  onChange,
  setAlert,
  setErrorCodeAndMessage,
  setHasAlert,
  title = 'LLM License Geography'
}) => {
  const [llmGeographies, setLlmGeographies] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const { getAccessTokenSilently: getAccessToken } = useAuth0()

  const inputHeight = useBreakpointValue({
    base: Styles.largeInputHeight,
    md: Styles.baseInputHeight
  })
  const checkboxClass = `${Styles.inputStyle} ${inputHeight}`

  const fetchData = async () => {
    try {
      !isLoading && setIsLoading(true)

      const orderBy = { orderField: 'name', noLimits: true }
      const geographies = await getLlmGeographies(orderBy, getAccessToken)

      setLlmGeographies(geographies)
    } catch (error) {
      console.log(error)
      setHasAlert && setHasAlert(true)
      setAlert && setAlert(setErrorCodeAndMessage(error))
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  if (isLoading) {
    return <CircleLoader isCentered={true} />
  }

  return (
    <InputCheckboxes
      checkboxGroupsClassName={checkboxClass}
      errorMessage={errors?.llmGeographiesIds?.message}
      label={title}
      labelKey="name"
      onChange={onChange}
      options={llmGeographies?.data}
      valueKey="id"
      defaultValue={defaultValue}
    />
  )
}

export default GeographiesCheckboxes
